import { Component } from '@angular/core';
import { HeaderLatestComponent } from 'src/app/home/landing-root/header-latest/header-latest.component';
import { PeopleflowFooterComponent } from 'src/app/peopleflow-footer/peopleflow-footer.component';
@Component({
  selector: 'app-webinars',
  imports: [
    HeaderLatestComponent,
    PeopleflowFooterComponent
  ],
  templateUrl: './webinars.html',
  styleUrl: './webinars.scss',
})
export class Webinars {

}
